<template>
    <div class="">
        <div class="top_title">
            <div class="top_back_home" @click="backToindex">
                <img src="../../../public/images/home.png" alt=""/>
                <p>返回首页</p>
            </div>
            <div class="title">
                羊场钱包
            </div>
        </div>
        <div class="main">
            <div class="wallet_yue">
                <div class="left">
                    总余额：
                    <p>¥ {{ totalBalance }}</p>
                </div>
                <!--                <div class="right">-->
                <!--                    当前日期：2026.02.06-->
                <!--                    <img src="../../../public/images/date.png" alt="" />-->
                <!--                </div>-->
            </div>

            <div class="wallet_title">
                <div class="top_title">
                    <div class="left">
                        <div class="ll">
                            羊场钱包
                        </div>
                        <div class="rr">
                            <el-date-picker size="mini" v-model="date_range" type="daterange" range-separator="~"
                                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                            start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                            <el-select v-model="wallet_role_id" placeholder="请选择对象" clearable size="mini">
                                <el-option v-for="item in walletRoleList" :key="item.id" :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                            <el-button type="primary" size="mini" @click="getWalletData(1)">查询</el-button>
                        </div>
                    </div>
                    <div class="right">
                        <div class="itt" @click="showAddWalletRole(0)">
                            <img src="../../../public/images/add.png" alt=""/>
                            <p>添加对象</p>
                        </div>
                        <div class="itt" @click="showWalletRole(1)">
                            <img src="../../../public/images/set.png" alt=""/>
                            <p>对象管理</p>
                        </div>

                    </div>
                </div>
                <div class="wallet_money_box">
                    <div class="itt">
                        <div class="tt">
                            总收入
                            <img src="../../../public/images/js1.png" alt=""/>
                        </div>
                        <div class="bb">
                            {{ totalRevenue }}
                        </div>
                        <div class="word">
                            平台总收入
                        </div>
                    </div>
                    <div class="itt">
                        <div class="tt">
                            总支出
                            <img src="../../../public/images/js2.png" alt=""/>
                        </div>
                        <div class="bb">
                            {{ totalExpenditure }}
                        </div>
                        <div class="word">
                            平台总支出
                        </div>
                    </div>
                    <!--                    <div class="itt">-->
                    <!--                        <div class="tt">-->
                    <!--                            总合计-->
                    <!--                            <img src="../../../public/images/js3.png" alt="" />-->
                    <!--                        </div>-->
                    <!--                        <div class="bb">-->
                    <!--                            5-->
                    <!--                        </div>-->
                    <!--                        <div class="word">-->
                    <!--                            总收入-总支出-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div class="itt">
                        <div class="tt">
                            余额
                            <img src="../../../public/images/js3.png" alt=""/>
                        </div>
                        <div class="bb">
                            {{ totalBalance }}
                        </div>
                        <div class="word">
                            总收入-总支出
                        </div>
                    </div>
                </div>
            </div>

            <!-- 收入记录 -->
            <div class="wallet_shouru">
                <div class="title">
                    <div class="left">
                        钱包记录
<!--                        <el-button size="small" type="primary" @click="showAddWallet(0, null)">新增</el-button>-->
                    </div>
                    <div class="right">
                        收入
                        <p>￥{{ rangeRevenue }}</p>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        支出
                        <p style="color: #4A5676;">￥{{ rangeExpenditure }}</p>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        合计
                        <p style="color: #FF4D4F;">￥{{ rangeBalance }}</p>
                    </div>
                </div>

                <el-row :gutter="20" class="table_jilu_box">
                    <el-col :span="12" class="table_shouru">
                        <div class="table_shouru_box">
                            <div class="table_shouru_box_title">
                                收入记录
<!--                                <el-button type="success">√保存新记录</el-button>-->
                            </div>
                            <el-table :data="revenueList" style="width: 100%" border>
                                <el-table-column prop="name" label="对象">
                                    <template slot-scope="scope">
                                        <el-select v-if="scope.row.is_edit == 1" @change="changeData(1, scope.$index)" size="small" v-model="scope.row.wallet_role_id" placeholder="请选择">
                                            <el-option
                                                v-for="item in walletRoleList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <span v-else>{{ scope.row.name }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="money" label="金额">
                                    <template slot-scope="scope">
                                        <el-input type="number" v-if="scope.row.is_edit == 1" @blur="changeData(1, scope.$index)" size="small" v-model="scope.row.money"></el-input>
                                        <span v-else>{{ scope.row.money }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="remark" label="备注">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.is_edit == 1" @blur="changeData(1, scope.$index)" size="small" v-model="scope.row.remark" placeholder="请输入内容"></el-input>
                                        <span v-else>{{ scope.row.remark }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="time" label="时间">
                                    <template slot-scope="scope">
                                        <el-date-picker v-if="scope.row.is_edit == 1"
                                                        size="small"
                                                        @change="changeData(1, scope.$index)"
                                                        v-model="scope.row.time"
                                                        type="date"
                                                        format="yyyy-MM-dd"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="选择日期">
                                        </el-date-picker>
                                        <span v-else>{{ scope.row.time }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="90">
                                    <template slot-scope="scope">
                                        <template v-if="scope.row.is_add == 1">
                                            <el-button type="text" size="mini" @click="delRow(1, scope.$index)"
                                                       style="color: #FF4D4F;">移除
                                            </el-button>
                                        </template>
                                        <template v-else>
                                            <template v-if="scope.row.is_edit == 1">
                                                <el-button type="text" size="small" @click="saveRow(1, scope.$index)">保存</el-button>
                                                <el-button type="text" size="small" @click="cancelRow(1, scope.$index)"
                                                           style="color: #484242;">取消
                                                </el-button>
                                            </template>
                                            <template v-else>
                                                <el-button type="text" size="small" @click="editRow(1, scope.$index)">编辑</el-button>
                                                <el-button type="text" size="small" @click="deleteWallet(scope.row.id)"
                                                           style="color: #FF4D4F;">删除
                                                </el-button>
                                            </template>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="add_jilu" style="cursor: pointer;" @click="addRow(1)">
                                +添加一行新记录
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12" class="table_zhichu">
                        <div class="table_zhichu_box">
                            <div class="table_zhichu_box_title">
                                支出记录
<!--                                <el-button type="danger">√保存新记录</el-button>-->
                            </div>
                            <el-table :data="expenditureList" style="width: 100%">
                                <el-table-column prop="name" label="对象">
                                    <template slot-scope="scope">
                                        <el-select v-if="scope.row.is_edit == 1" @change="changeData(2, scope.$index)" size="small" v-model="scope.row.wallet_role_id" placeholder="请选择">
                                            <el-option
                                                v-for="item in walletRoleList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <span v-else>{{ scope.row.name }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="money" label="金额">
                                    <template slot-scope="scope">
                                        <el-input type="number" v-if="scope.row.is_edit == 1" @blur="changeData(2, scope.$index)" size="small" v-model="scope.row.money" ></el-input>
                                        <span v-else>{{ scope.row.money }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="remark" label="备注">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.is_edit == 1" @blur="changeData(2, scope.$index)" size="small" v-model="scope.row.remark" placeholder="请输入内容"></el-input>
                                        <span v-else>{{ scope.row.remark }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="time" label="时间">
                                    <template slot-scope="scope">
                                        <el-date-picker v-if="scope.row.is_edit == 1"
                                                        size="small"
                                                        @change="changeData(2, scope.$index)"
                                                        v-model="scope.row.time"
                                                        type="date"
                                                        format="yyyy-MM-dd"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="选择日期">
                                        </el-date-picker>
                                        <span v-else>{{ scope.row.time }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="90">
                                    <template slot-scope="scope">
                                        <template v-if="scope.row.is_add == 1">
                                            <el-button type="text" size="mini" @click="delRow(2, scope.$index)"
                                                       style="color: #FF4D4F;">移除
                                            </el-button>
                                        </template>
                                        <template v-else>
                                            <template v-if="scope.row.is_edit == 1">
                                                <el-button type="text" size="small" @click="saveRow(2, scope.$index)">保存</el-button>
                                                <el-button type="text" size="small" @click="cancelRow(2, scope.$index)"
                                                           style="color: #484242;">取消
                                                </el-button>
                                            </template>
                                            <template v-else>
                                                <el-button type="text" size="small" @click="editRow(2, scope.$index)">编辑</el-button>
                                                <el-button type="text" size="small" @click="deleteWallet(scope.row.id)"
                                                           style="color: #FF4D4F;">删除
                                                </el-button>
                                            </template>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="add_jilu" style="cursor: pointer;" @click="addRow(2)">
                                +添加一行新记录
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

<!--        <el-dialog-->
<!--            title="钱包记录"-->
<!--            :visible.sync="showAddWalletStatus"-->
<!--            width="60%"-->
<!--            center>-->
<!--            <div class="dialog-content">-->
<!--                <div class="dialog-body">-->
<!--                    <el-form :rules="walletFormRules" ref="walletForm" :model="walletForm" label-width="100px">-->
<!--                        <el-form-item label="对象：" prop="wallet_role_id">-->
<!--                            <el-select v-model="walletForm.wallet_role_id" placeholder="请选择对象">-->
<!--                                <el-option v-for="item in walletRoleList" :label="item.name"-->
<!--                                           :value="item.id"></el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="类型：" prop="type">-->
<!--                            <el-select v-model="walletForm.type" placeholder="请选择类型">-->
<!--                                <el-option label="收入" value="1"></el-option>-->
<!--                                <el-option label="支出" value="2"></el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->

<!--                        <el-form-item label="金额：" prop="money">-->
<!--                            <el-input-number v-model="walletForm.money" :min="0" clearable></el-input-number>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="时间：" prop="time">-->
<!--                            <el-date-picker-->
<!--                                v-model="walletForm.time"-->
<!--                                value-format="yyyy-MM-dd"-->
<!--                                format="yyyy-MM-dd"-->
<!--                                type="date"-->
<!--                                placeholder="选择日期">-->
<!--                            </el-date-picker>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="备注：" prop="remark">-->
<!--                            <el-input type="textarea" v-model="walletForm.remark" rows="2" clearable></el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-form>-->
<!--                </div>-->
<!--            </div>-->
<!--            <span slot="footer" class="dialog-footer">-->
<!--                <el-button @click="closeAddWalletStatus">取 消</el-button>-->
<!--                <el-button type="primary" @click="submitAddWallet">确 定</el-button>-->
<!--              </span>-->
<!--        </el-dialog>-->

        <!-- 添加对象弹窗-->
        <el-dialog
            title="添加对象"
            :visible.sync="showAddWalletRoleDialog"
            width="60%"
            center>
            <div class="dialog-content">
                <div class="dialog-body">
                    <el-form ref="form" :model="walletRoleForm" label-width="100px">
                        <el-form-item label="对象名称：">
                            <el-input v-model="walletRoleForm.name" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="对象类型：">
                            <el-select v-model="walletRoleForm.type" placeholder="请选择类型">
                                <el-option v-for="item in walletRoleFormTypeArr" :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input type="textarea" v-model="walletRoleForm.remark" rows="2" clearable></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeAddWalletRoleDialog">取 消</el-button>
                <el-button type="primary" @click="sureEditWalletRole">确 定</el-button>
              </span>
        </el-dialog>

        <!-- 对象管理弹窗-->
        <el-dialog
            title="对象管理"
            :visible.sync="showDialogWalletRole"
            width="70%"
            center>
            <div class="dialog-content">
                <div class="dialog-body">
                    <div class="table">
                        <el-table :data="walletRoleList" style="width: 100%" height="260">
                            <el-table-column prop="name" label="对象名称">
                            </el-table-column>
                            <el-table-column prop="classstyle" label="对象类型">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.type == 1" disable-transitions size="mini">
                                        通用对象
                                    </el-tag>
                                    <el-tag v-if="scope.row.type == 2" disable-transitions size="mini"
                                            type="success">
                                        收入对象
                                    </el-tag>
                                    <el-tag v-if="scope.row.type == 3" disable-transitions size="mini"
                                            type="warning">
                                        支出对象
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="desc" label="备注">
                            </el-table-column>

                            <el-table-column label="操作" width="90">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="showAddWalletRole(scope.row.id)">编辑
                                    </el-button>
                                    <el-button type="text" size="small"
                                               @click="delWalletRole(scope.row.id)"
                                               style="color: #FF4D4F;">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeWalletRole">取 消</el-button>
              </span>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data() {
        return {
            date_range: '',
            wallet_role_id: '',
            totalRevenue: '', // 总收入
            totalExpenditure: '', // 总支出
            totalBalance: '', // 总余额
            rangeRevenue: '', // 区间收入
            rangeExpenditure: '', // 区间支出
            rangeBalance: '', // 区间合计
            revenueList: [],
            expenditureList: [],
            oldRevenueList: [],
            oldExpenditureList: [],

            showAddWalletStatus: false,
            walletForm: {},
            walletFormRules: {
                wallet_role_id: [
                    { required: true, message: '请选择对象', trigger: 'change' }
                ],
                type: [
                    { required: true, message: '请选择类型', trigger: 'change' }
                ],
                money: [
                    { required: true, message: '请输入金额', trigger: 'blur' },
                ],
                time: [
                    { required: true, message: '请选择日期', trigger: 'change' }
                ],
            },

            //添加对象
            showAddWalletRoleDialog: false,
            walletRoleForm: {
                id: 0,
                name: '',
                type: '',
                remark: '',
            },

            //对象管理
            showDialogWalletRole: false,
            walletRoleList: [],
            walletRoleFormTypeArr: [
                {
                    value: 1,
                    label: '通用对象'
                }, {
                    value: 2,
                    label: '收入对象'
                }, {
                    value: 3,
                    label: '支出对象'
                },
            ],
        }
    },
    mounted() {
        this.date_range = [this.getCurrentDate(), this.getCurrentDate()];
        this.getWalletData(1);
        this.showWalletRole(0);
    },
    methods: {
        getCurrentDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        //返回首页
        backToindex() {
            this.$router.push({
                path: '/',
            })
        },

        getWalletData(isShow = 1) {
            let loading = '';
            if(isShow == 1){
                loading = this.$loading({
                    "lock": true,
                    "text": '',
                    "spinner": 'el-icon-loading',
                    "background": 'rgba(0, 0, 0, 0.7)'
                });
            }

            this.$http.post('/wallet/getWalletData', {
                daterange: this.date_range,
                wallet_role_id: this.wallet_role_id,
            }).then(res => {
                if(isShow == 1){
                    loading.close();
                }

                if (res.data.code == 0) {
                    this.totalRevenue = res.data.data.totalRevenue;
                    this.totalExpenditure = res.data.data.totalExpenditure;
                    this.totalBalance = res.data.data.totalBalance;
                    this.rangeRevenue = res.data.data.rangeRevenue;
                    this.rangeExpenditure = res.data.data.rangeExpenditure;
                    this.rangeBalance = res.data.data.rangeBalance;
                    this.revenueList = res.data.data.revenueList;
                    if(isShow == 1){
                        this.revenueList.forEach(row => {
                            this.$set(row, 'is_edit', 0); // 初始为不可编辑
                            this.$set(row, 'is_add', 0); // 初始为不可编辑
                        });
                    }
                    this.expenditureList = res.data.data.expenditureList;
                    if(isShow == 1){
                        this.expenditureList.forEach(row => {
                            this.$set(row, 'is_edit', 0); // 初始为不可编辑
                            this.$set(row, 'is_add', 0); // 初始为不可编辑
                        });
                    }
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },
        // 展示添加钱包记录表单
        showAddWallet(id = 0, row = null) {
            const loading = this.$loading({
                "lock": true,
                "text": '',
                "spinner": 'el-icon-loading',
                "background": 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/wallet_role/getWalletRoleList').then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.walletRoleList = res.data.data;
                    if(id == 0){
                        this.walletForm = {
                            id: 0,
                            wallet_role_id: '',
                            type: '1',
                            money: '',
                            remark: '',
                            time: this.getCurrentDate(),
                        };
                    }else{
                        this.walletForm = row;
                        this.walletForm.type = this.walletForm.type + "";
                    }
                    this.showAddWalletStatus = true;
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },
        // submitAddWallet() {
        //     this.$refs['walletForm'].validate((valid) => {
        //         if (valid) {
        //             const loading = this.$loading({
        //                 "lock": true,
        //                 "text": '',
        //                 "spinner": 'el-icon-loading',
        //                 "background": 'rgba(0, 0, 0, 0.7)'
        //             });
        //             this.$http.post('/wallet/edit', this.walletForm).then(res => {
        //                 loading.close();
        //                 if (res.data.code == 0) {
        //                     this.closeAddWalletStatus();
        //                     this.getWalletData(1);
        //                 } else {
        //                     this.$message({
        //                         "type": 'error',
        //                         "message": res.data.msg
        //                     })
        //                 }
        //             });
        //         } else {
        //             return false;
        //         }
        //     });
        // },
        // closeAddWalletStatus(){
        //     this.showAddWalletStatus = false;
        // },
        deleteWallet(id){
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/wallet/delete', {
                    id: id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.getWalletData(1);
                            }
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },

        // 添加对象弹窗
        showAddWalletRole(id = 0) {
            if (id == 0) {
                this.walletRoleForm = {
                    id: 0,
                    name: '',
                    type: '',
                    remark: '',
                };
                this.showAddWalletRoleDialog = true;
            } else {
                const loading = this.$loading({
                    "lock": true,
                    "text": '',
                    "spinner": 'el-icon-loading',
                    "background": 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/wallet_role/info', {id: id}).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.walletRoleForm = res.data.data;
                        this.showAddWalletRoleDialog = true;
                    } else {
                        this.$message({
                            "type": 'error',
                            "message": res.data.msg
                        })
                    }
                });
            }
        },
        closeAddWalletRoleDialog() {
            this.showAddWalletRoleDialog = false;
        },
        // 确定编辑对象
        sureEditWalletRole() {
            if (this.walletRoleForm.name == '') {
                this.$message({
                    "type": 'error',
                    "message": '请输入对象名称',
                })
                return false;
            }
            if ((+this.walletRoleForm.type) <= 0) {
                this.$message({
                    "type": 'error',
                    "message": '请选择类型',
                })
                return false;
            }
            const loading = this.$loading({
                "lock": true,
                "text": '',
                "spinner": 'el-icon-loading',
                "background": 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/wallet_role/editWalletRole', this.walletRoleForm).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.closeAddWalletRoleDialog();
                            this.showWalletRole(0);
                        }
                    });
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },

        // 对象管理弹窗
        showWalletRole(showPage = 1) {
            const loading = this.$loading({
                "lock": true,
                "text": '',
                "spinner": 'el-icon-loading',
                "background": 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/wallet_role/getWalletRoleList').then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.walletRoleList = res.data.data;
                    if (showPage == 1) {
                        this.showDialogWalletRole = true;
                    }
                } else {
                    this.$message({
                        "type": 'error',
                        "message": res.data.msg
                    })
                }
            });
        },
        closeWalletRole() {
            this.showDialogWalletRole = false;
        },
        delWalletRole(id) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/wallet_role/delete', {
                    id: id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.showWalletRole(0);
                            }
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },

        // 添加一行
        addRow(type = 1){
            if(type == 1){
                // 收入
                this.revenueList.push({
                    id: 0,
                    wallet_role_id: '',
                    money: '',
                    remark: '',
                    time: this.getCurrentDate(),
                    is_edit: 1,
                    is_add: 1,
                });
            }else{
                // 支出
                this.expenditureList.push({
                    id: 0,
                    wallet_role_id: '',
                    money: '',
                    remark: '',
                    time: this.getCurrentDate(),
                    is_edit: 1,
                    is_add: 1,
                });
            }
        },
        changeData(type, index){
            var data = {};
            if(type == 1){
                data = this.revenueList[index];
            }else{
                data = this.expenditureList[index];
            }
            if((+data.wallet_role_id) > 0 && (+data.money) > 0 && data.is_add == 1){
                data.type = type;
                data.search = {
                    daterange: this.date_range,
                    wallet_role_id: this.wallet_role_id,
                };
                this.$http.post('/wallet/edit', data).then(res => {
                    if (res.data.code == 0) {
                        if(type == 1){
                            this.revenueList[index].id = res.data.data.id;
                        }else{
                            this.expenditureList[index].id = res.data.data.id;
                        }
                        this.totalRevenue = res.data.data.totalRevenue;
                        this.totalExpenditure = res.data.data.totalExpenditure;
                        this.totalBalance = res.data.data.totalBalance;
                        this.rangeRevenue = res.data.data.rangeRevenue;
                        this.rangeExpenditure = res.data.data.rangeExpenditure;
                        this.rangeBalance = res.data.data.rangeBalance;
                    } else {
                        this.$message({
                            "type": 'error',
                            "message": res.data.msg
                        })
                    }
                });

            }
        },
        delRow(type, index){
            if(type == 1){
                if(this.revenueList[index].id > 0){
                    this.deleteWallet(this.revenueList[index].id);
                }else{
                    var newRevenueList = [];
                    for (var i=0; i<this.revenueList.length; i++) {
                        if(index != i){
                            newRevenueList.push(this.revenueList[i]);
                        }
                    }
                    this.revenueList = newRevenueList;
                }
            }else{
                if(this.expenditureList[index].id > 0){
                    this.deleteWallet(this.expenditureList[index].id);
                }else{
                    var newExpenditureList = [];
                    for (var i=0; i<this.expenditureList.length; i++) {
                        if(index != i){
                            newExpenditureList.push(this.expenditureList[i]);
                        }
                    }
                    this.expenditureList = newExpenditureList;
                }
            }
        },
        // 保存
        saveRow(type, index){
            var data = {};
            if(type == 1){
                data = this.revenueList[index]
            }else{
                data = this.expenditureList[index]
            }
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/wallet/edit', data).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.getWalletData(1);
                        }
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        editRow(type, index){
            if(type == 1){
                for (var i=0; i<this.revenueList.length; i++) {
                    if(index == i){
                        this.revenueList[i].is_edit = 1;
                        this.handleOldData(type, this.revenueList[i], 1);
                    }
                }
            }else{
                for (var i=0; i<this.expenditureList.length; i++) {
                    if(index == i){
                        this.expenditureList[i].is_edit = 1;
                        this.handleOldData(type, this.expenditureList[i], 1);
                    }
                }
            }
        },
        cancelRow(type, index){
            if(type == 1){
                for (var i=0; i<this.revenueList.length; i++) {
                    if(index == i){
                        var oldData = this.getOldData(type, this.revenueList[i].id);
                        this.revenueList[i].is_edit = 0;
                        this.revenueList[i].wallet_role_id = oldData.wallet_role_id;
                        this.revenueList[i].money = oldData.money;
                        this.revenueList[i].remark = oldData.remark;
                        this.revenueList[i].time = oldData.time;
                        this.handleOldData(type, this.revenueList[i], 0);
                    }
                }
            }else{
                for (var i=0; i<this.expenditureList.length; i++) {
                    if(index == i){
                        var oldData = this.getOldData(type, this.expenditureList[i].id);
                        this.expenditureList[i].is_edit = 0;
                        this.expenditureList[i].wallet_role_id = oldData.wallet_role_id;
                        this.expenditureList[i].money = oldData.money;
                        this.expenditureList[i].remark = oldData.remark;
                        this.expenditureList[i].time = oldData.time;
                        this.handleOldData(type, this.expenditureList[i], 0);
                    }
                }
            }
        },
        // 旧数据处理
        handleOldData(type, item, isAdd){
            if(isAdd == 1){
                if(type == 1){
                    var isHave = false;
                    for (var m=0; m<this.oldRevenueList.length; m++) {
                        if(item.id == this.oldRevenueList[m].id){
                            this.oldRevenueList[m].id = item.id;
                            this.oldRevenueList[m].wallet_role_id = item.wallet_role_id;
                            this.oldRevenueList[m].money = item.money;
                            this.oldRevenueList[m].remark = item.remark;
                            this.oldRevenueList[m].time = item.time;
                            isHave = true;
                        }
                    }
                    if(!isHave){
                        this.oldRevenueList.push({
                            id: item.id,
                            wallet_role_id: item.wallet_role_id,
                            money: item.money,
                            remark: item.remark,
                            time: item.time,
                        });
                    }
                }else{
                    var isHave = false;
                    for (var m=0; m<this.oldExpenditureList.length; m++) {
                        if(item.id == this.oldExpenditureList[m].id){
                            this.oldExpenditureList[m].id = item.id;
                            this.oldExpenditureList[m].wallet_role_id = item.wallet_role_id;
                            this.oldExpenditureList[m].money = item.money;
                            this.oldExpenditureList[m].remark = item.remark;
                            this.oldExpenditureList[m].time = item.time;
                            isHave = true;
                        }
                    }
                    if(!isHave){
                        this.oldExpenditureList.push({
                            id: item.id,
                            wallet_role_id: item.wallet_role_id,
                            money: item.money,
                            remark: item.remark,
                            time: item.time,
                        });
                    }
                }
            }else{
                // 删除
                if(type == 1){
                    var newOldRevenueList = [];
                    for (var m=0; m<this.oldRevenueList.length; m++) {
                        if(item.id != this.oldRevenueList[m].id){
                            newOldRevenueList.push(this.oldRevenueList[m]);
                        }
                    }
                    this.oldRevenueList = newOldRevenueList;
                }else{
                    var newOldExpenditureList = [];
                    for (var m=0; m<this.oldExpenditureList.length; m++) {
                        if(item.id != this.oldExpenditureList[m].id){
                            newOldExpenditureList.push(this.oldExpenditureList[m]);
                        }
                    }
                    this.oldExpenditureList = newOldExpenditureList;
                }
            }
        },
        // 获取老数据
        getOldData(type, id)
        {
            if(type == 1){
                for (var m=0; m<this.oldRevenueList.length; m++) {
                    if(id == this.oldRevenueList[m].id){
                        return this.oldRevenueList[m];
                    }
                }
            }else{
                for (var m=0; m<this.oldExpenditureList.length; m++) {
                    if(id == this.oldExpenditureList[m].id){
                        return this.oldExpenditureList[m];
                    }
                }
            }
        },
    }
}
</script>

<style lang="less" scoped>
.main {
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 20px;

    .wallet_yue {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .left {
            display: flex;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 24px;

            p {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 36px;
            }
        }

        .right {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 24px;
            display: flex;
            align-items: center;

            img {
                display: block;
                width: 24px;
                height: 24px;
                margin-left: 8px;
            }
        }
    }

    .wallet_title {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;
        box-sizing: border-box;

        .top_title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                padding-left: 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                position: relative;
                display: flex;
                align-items: center;

                .rr {
                    display: flex;
                    align-items: center;
                    padding-left: 10px;

                    .el-select {
                        padding: 0 10px;
                    }
                }
            }

            .left::after {
                content: '';
                display: block;
                width: 4px;
                height: 17px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
                position: absolute;
                left: 0;
                top: 12px;
            }

            .right {
                display: flex;
                align-items: center;

                .itt {
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 16px;
                        height: 16px;
                        margin-right: 4px;
                    }

                    p {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #3F72FF;
                    }
                }

                .itt:first-child {
                    margin-right: 20px;
                }
            }
        }

        .wallet_money_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;

            .itt {
                flex: 0 0 24%;
                background: #e8e8e8;
                border-radius: 8px 8px 8px 8px;
                padding: 16px;
                box-sizing: border-box;

                .tt {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #4A5676;
                    line-height: 22px;

                    img {
                        display: block;
                        width: 20px;
                        height: 20px;
                    }
                }

                .bb {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 24px;
                    color: #333;
                    line-height: 32px;
                    padding: 4px 0;
                }
            }

            .itt:first-child {
                background: #F5F6FC;

                .bb {
                    color: #3F72FF;
                }

                .word {
                    color: #4A5676;
                }
            }

            .itt:nth-child(2) {
                background: #FFFBEF;

                .bb {
                    color: #FFCC00;
                }

                .word {
                    color: #76674A;
                }
            }

            .itt:nth-child(3) {
                background: #FCF5F5;

                .bb {
                    color: #FF4D4F;
                }

                .word {
                    color: #764A4B;
                }
            }

            .itt:last-child {
                background: #F5FCF5;

                .bb {
                    color: #389F0D;
                }

                .word {
                    color: #59764A;
                }
            }
        }
    }

    .wallet_shouru {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                padding-left: 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                width: 4px;
                height: 17px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
                position: absolute;
                left: 0;
                top: 5px;
            }

            .right {
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #4A5676;
                line-height: 22px;

                p {
                    font-weight: 500;
                    font-size: 24px;
                    color: #52C41A;
                    line-height: 36px;
                }
            }
        }

        .table {
            .actions {
                width: 100%;
                border-radius: 4px 4px 4px 4px;
                border: 1px dashed #C1D0FB;
                text-align: center;
                margin-top: 8px;

                .el-button {
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 40px;
                    height: 40px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }
        }

        .table_jilu_box{
            .table_shouru{
                padding-left: 0 !important;
                .table_shouru_box{
                    border: 2px solid #67c23a;
                    border-radius: 10px;
                    overflow: hidden;
                    .table_shouru_box_title{
                        color: #333;
                        font-size: 18px;
                        background: #f8f9fa;
                        line-height: 50px;
                        padding: 0 20px;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .add_jilu{
                        line-height: 50px;
                        text-align: center;
                        color: #67c23a;
                        font-size: 16px;
                        background: #f8f9fa;
                        border-bottom: 2px solid #67c23a;
                    }
                    .zong_shouru{
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 50px;
                        color: #333;
                        padding: 0 10px;
                        box-sizing: border-box;
                        span{
                            color: #67c23a;
                        }
                    }
                }
            }
            .table_zhichu{
                padding-right: 0 !important;
                .table_zhichu_box{
                    border: 2px solid #f56c6c;
                    border-radius: 10px;
                    overflow: hidden;
                    .table_zhichu_box_title{
                        color: #f56c6c;
                        font-size: 18px;
                        background: #fff5f5;
                        line-height: 50px;
                        padding: 0 20px;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .add_jilu{
                        line-height: 50px;
                        text-align: center;
                        color: #f56c6c;
                        font-size: 16px;
                        background: #fef0f0;
                        border-bottom: 2px solid #f56c6c;
                    }
                    .zong_zhichu{
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 50px;
                        color: #333;
                        padding: 0 10px;
                        box-sizing: border-box;
                        span{
                            color: #f56c6c;
                        }
                    }
                }
            }
        }
    }

    .wallet_zhichu {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                padding-left: 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                width: 4px;
                height: 17px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
                position: absolute;
                left: 0;
                top: 5px;
            }

            .right {
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #4A5676;
                line-height: 22px;

                p {
                    font-weight: 500;
                    font-size: 24px;
                    color: #FF4D4F;
                    line-height: 36px;
                }
            }
        }

        .table {
            .actions {
                width: 100%;
                border-radius: 4px 4px 4px 4px;
                border: 1px dashed #C1D0FB;
                text-align: center;
                margin-top: 8px;

                .el-button {
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 40px;
                    height: 40px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }
        }
    }

}

.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;

    .dialog-content {
        background: white;
        border-radius: 8px;
        width: 80%;
        max-width: 90%;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        padding: 24px;

        .dialog-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #4A5676;
            margin-bottom: 26px;

            img {
                display: block;
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        }

        .dialog-body {
            .item {
                margin-bottom: 20px;

                .title {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #36363A;
                    margin-bottom: 12px;

                    span {
                        color: #CB2D18;
                    }
                }

                .con {
                    .el-select {
                        width: 100%;
                    }
                }
            }

            .el-row {
                margin-top: 20px;
            }

            .grid-title {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #36363A;
                line-height: 40px;
            }

            .grid-input {
                .el-input {
                    .el-input__prefix {
                        line-height: 40px;
                    }
                }
            }


            .table {
                .el-table tr {
                    background: #F5F6FC !important;
                }

                .el-button {
                    img {
                        display: block;
                        width: 16px;
                        height: 16px;
                    }
                }

                .actions {
                    width: 100%;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px dashed #C1D0FB;
                    text-align: center;
                    margin-top: 8px;

                    .el-button {
                        margin: 0 auto;
                        border: 0;
                        padding: 0;
                        line-height: 40px;
                        height: 40px;
                        width: 100%;
                        display: block;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #3F72FF;
                    }
                }

                .submit {
                    margin-top: 30px;
                    width: 100%;
                    border-radius: 60px;
                    line-height: 60px;
                    text-align: center;

                    .el-button {
                        background: #3F72FF;
                        margin: 0 auto;
                        border: 0;
                        padding: 0;
                        line-height: 60px;
                        height: 60px;
                        border-radius: 60px;
                        width: 100%;
                        display: block;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                }
            }

            .control {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 20px;

                .itt {
                    width: 96px;
                    height: 40px;
                    border-radius: 4px 4px 4px 4px;
                    box-sizing: border-box;
                    line-height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    text-align: center;
                    margin-left: 16px;
                    cursor: pointer;
                }

                .quxiao {
                    border: 1px solid #E5E5E7;
                    color: #36363A;

                }

                .sure {
                    background: #3F72FF;
                    border: 1px solid #3F72FF;
                    color: #FFFFFF;
                }
            }


            .jiesuan_money_box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 16px;
                margin-bottom: 20px;

                .itt {
                    flex: 0 0 32%;
                    background: #e8e8e8;
                    border-radius: 8px 8px 8px 8px;
                    padding: 16px;
                    box-sizing: border-box;

                    .tt {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                        line-height: 22px;
                        margin-bottom: 4px;

                        img {
                            display: block;
                            width: 20px;
                            height: 20px;
                        }
                    }

                    .bb {
                        font-family: DIN, DIN;
                        font-weight: 500;
                        font-size: 24px;
                        color: #333;
                        line-height: 32px;
                    }
                }

                .itt:first-child {
                    background: #F5F6FC;

                    .bb {
                        color: #3F72FF;
                    }
                }

                .itt:nth-child(2) {
                    background: #FFFBEF;

                    .bb {
                        color: #FFCC00;
                    }
                }

                .itt:last-child {
                    background: #F5FCF5;

                    .bb {
                        color: #389F0D;
                    }
                }
            }

            .product_mingxi {
                margin-bottom: 20px;

                .tt {
                    display: flex;
                    align-items: center;
                    background: #F5F6FC;

                    p {
                        flex: 1;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9B9CA1;
                        line-height: 24px;
                        padding: 12px 0 12px 6px;
                        box-sizing: border-box;
                    }
                }

                .bb {
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #F0F0F0;

                    p {
                        flex: 1;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #4A5676;
                        line-height: 24px;
                        padding: 12px 0 12px 6px;
                        box-sizing: border-box;

                        span {
                            color: #3F72FF;
                        }
                    }
                }
            }

            .chengben_mingxi {
                display: flex;
                align-items: center;
                background: #F5F6FC;

                .itte {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #9B9CA1;
                    line-height: 22px;
                    padding: 12px;
                    box-sizing: border-box;

                    p {
                        color: #36363A;
                        margin-top: 4px;
                    }

                    span {
                        color: #FF4D4F;
                    }
                }
            }
        }
    }
}
</style>
